/**
 * #widgets_msg.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { BoolValue, Int32Value, Int64Value, StringValue } from "../../../../google/protobuf/wrappers.js";
import { messageTypeRegistry } from "../../../../typeRegistry.js";
import { AuthorFlairRichText } from "../../../reddit/common.js";
function createBaseWidgetStyles() {
    return { backgroundColor: undefined, headerColor: undefined };
}
export const WidgetStyles = {
    $type: "devvit.plugin.redditapi.widgets.WidgetStyles",
    encode(message, writer = _m0.Writer.create()) {
        if (message.backgroundColor !== undefined) {
            StringValue.encode({ value: message.backgroundColor }, writer.uint32(10).fork()).ldelim();
        }
        if (message.headerColor !== undefined) {
            StringValue.encode({ value: message.headerColor }, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWidgetStyles();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.backgroundColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.headerColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            backgroundColor: isSet(object.backgroundColor) ? String(object.backgroundColor) : undefined,
            headerColor: isSet(object.headerColor) ? String(object.headerColor) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.backgroundColor !== undefined) {
            obj.backgroundColor = message.backgroundColor;
        }
        if (message.headerColor !== undefined) {
            obj.headerColor = message.headerColor;
        }
        return obj;
    },
    create(base) {
        return WidgetStyles.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWidgetStyles();
        message.backgroundColor = object.backgroundColor ?? undefined;
        message.headerColor = object.headerColor ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(WidgetStyles.$type, WidgetStyles);
function createBaseWidgetImage() {
    return { url: "", linkUrl: "", height: 0, width: 0 };
}
export const WidgetImage = {
    $type: "devvit.plugin.redditapi.widgets.WidgetImage",
    encode(message, writer = _m0.Writer.create()) {
        if (message.url !== "") {
            writer.uint32(10).string(message.url);
        }
        if (message.linkUrl !== "") {
            writer.uint32(18).string(message.linkUrl);
        }
        if (message.height !== 0) {
            writer.uint32(24).int32(message.height);
        }
        if (message.width !== 0) {
            writer.uint32(32).int32(message.width);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWidgetImage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.linkUrl = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.height = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.width = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            url: isSet(object.url) ? globalThis.String(object.url) : "",
            linkUrl: isSet(object.linkUrl) ? globalThis.String(object.linkUrl) : "",
            height: isSet(object.height) ? globalThis.Number(object.height) : 0,
            width: isSet(object.width) ? globalThis.Number(object.width) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.url !== "") {
            obj.url = message.url;
        }
        if (message.linkUrl !== "") {
            obj.linkUrl = message.linkUrl;
        }
        if (message.height !== 0) {
            obj.height = Math.round(message.height);
        }
        if (message.width !== 0) {
            obj.width = Math.round(message.width);
        }
        return obj;
    },
    create(base) {
        return WidgetImage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWidgetImage();
        message.url = object.url ?? "";
        message.linkUrl = object.linkUrl ?? "";
        message.height = object.height ?? 0;
        message.width = object.width ?? 0;
        return message;
    },
};
messageTypeRegistry.set(WidgetImage.$type, WidgetImage);
function createBaseImageWidget() {
    return { id: "", kind: "", data: [], shortName: "", styles: undefined, subreddit: undefined };
}
export const ImageWidget = {
    $type: "devvit.plugin.redditapi.widgets.ImageWidget",
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.kind !== "") {
            writer.uint32(18).string(message.kind);
        }
        for (const v of message.data) {
            WidgetImage.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (message.shortName !== "") {
            writer.uint32(34).string(message.shortName);
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(42).fork()).ldelim();
        }
        if (message.subreddit !== undefined) {
            StringValue.encode({ value: message.subreddit }, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseImageWidget();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.data.push(WidgetImage.decode(reader, reader.uint32()));
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.subreddit = StringValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            data: globalThis.Array.isArray(object?.data) ? object.data.map((e) => WidgetImage.fromJSON(e)) : [],
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
            subreddit: isSet(object.subreddit) ? String(object.subreddit) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.data?.length) {
            obj.data = message.data.map((e) => WidgetImage.toJSON(e));
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        if (message.subreddit !== undefined) {
            obj.subreddit = message.subreddit;
        }
        return obj;
    },
    create(base) {
        return ImageWidget.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseImageWidget();
        message.id = object.id ?? "";
        message.kind = object.kind ?? "";
        message.data = object.data?.map((e) => WidgetImage.fromPartial(e)) || [];
        message.shortName = object.shortName ?? "";
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        message.subreddit = object.subreddit ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(ImageWidget.$type, ImageWidget);
function createBaseAddImageWidgetRequest() {
    return { subreddit: "", data: [], shortName: "", styles: undefined };
}
export const AddImageWidgetRequest = {
    $type: "devvit.plugin.redditapi.widgets.AddImageWidgetRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        for (const v of message.data) {
            WidgetImage.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.shortName !== "") {
            writer.uint32(26).string(message.shortName);
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAddImageWidgetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data.push(WidgetImage.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            data: globalThis.Array.isArray(object?.data) ? object.data.map((e) => WidgetImage.fromJSON(e)) : [],
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.data?.length) {
            obj.data = message.data.map((e) => WidgetImage.toJSON(e));
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        return obj;
    },
    create(base) {
        return AddImageWidgetRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddImageWidgetRequest();
        message.subreddit = object.subreddit ?? "";
        message.data = object.data?.map((e) => WidgetImage.fromPartial(e)) || [];
        message.shortName = object.shortName ?? "";
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(AddImageWidgetRequest.$type, AddImageWidgetRequest);
function createBaseUpdateImageWidgetRequest() {
    return { subreddit: "", id: "", data: [], shortName: "", styles: undefined };
}
export const UpdateImageWidgetRequest = {
    $type: "devvit.plugin.redditapi.widgets.UpdateImageWidgetRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.id !== "") {
            writer.uint32(18).string(message.id);
        }
        for (const v of message.data) {
            WidgetImage.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (message.shortName !== "") {
            writer.uint32(34).string(message.shortName);
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateImageWidgetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.data.push(WidgetImage.decode(reader, reader.uint32()));
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            data: globalThis.Array.isArray(object?.data) ? object.data.map((e) => WidgetImage.fromJSON(e)) : [],
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.data?.length) {
            obj.data = message.data.map((e) => WidgetImage.toJSON(e));
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        return obj;
    },
    create(base) {
        return UpdateImageWidgetRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateImageWidgetRequest();
        message.subreddit = object.subreddit ?? "";
        message.id = object.id ?? "";
        message.data = object.data?.map((e) => WidgetImage.fromPartial(e)) || [];
        message.shortName = object.shortName ?? "";
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(UpdateImageWidgetRequest.$type, UpdateImageWidgetRequest);
function createBaseCalendarWidgetConfiguration() {
    return {
        numEvents: 0,
        showDate: false,
        showDescription: false,
        showLocation: false,
        showTime: false,
        showTitle: false,
    };
}
export const CalendarWidgetConfiguration = {
    $type: "devvit.plugin.redditapi.widgets.CalendarWidgetConfiguration",
    encode(message, writer = _m0.Writer.create()) {
        if (message.numEvents !== 0) {
            writer.uint32(8).int32(message.numEvents);
        }
        if (message.showDate !== false) {
            writer.uint32(16).bool(message.showDate);
        }
        if (message.showDescription !== false) {
            writer.uint32(24).bool(message.showDescription);
        }
        if (message.showLocation !== false) {
            writer.uint32(32).bool(message.showLocation);
        }
        if (message.showTime !== false) {
            writer.uint32(40).bool(message.showTime);
        }
        if (message.showTitle !== false) {
            writer.uint32(48).bool(message.showTitle);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCalendarWidgetConfiguration();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.numEvents = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.showDate = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.showDescription = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.showLocation = reader.bool();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.showTime = reader.bool();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.showTitle = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            numEvents: isSet(object.numEvents) ? globalThis.Number(object.numEvents) : 0,
            showDate: isSet(object.showDate) ? globalThis.Boolean(object.showDate) : false,
            showDescription: isSet(object.showDescription) ? globalThis.Boolean(object.showDescription) : false,
            showLocation: isSet(object.showLocation) ? globalThis.Boolean(object.showLocation) : false,
            showTime: isSet(object.showTime) ? globalThis.Boolean(object.showTime) : false,
            showTitle: isSet(object.showTitle) ? globalThis.Boolean(object.showTitle) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.numEvents !== 0) {
            obj.numEvents = Math.round(message.numEvents);
        }
        if (message.showDate !== false) {
            obj.showDate = message.showDate;
        }
        if (message.showDescription !== false) {
            obj.showDescription = message.showDescription;
        }
        if (message.showLocation !== false) {
            obj.showLocation = message.showLocation;
        }
        if (message.showTime !== false) {
            obj.showTime = message.showTime;
        }
        if (message.showTitle !== false) {
            obj.showTitle = message.showTitle;
        }
        return obj;
    },
    create(base) {
        return CalendarWidgetConfiguration.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCalendarWidgetConfiguration();
        message.numEvents = object.numEvents ?? 0;
        message.showDate = object.showDate ?? false;
        message.showDescription = object.showDescription ?? false;
        message.showLocation = object.showLocation ?? false;
        message.showTime = object.showTime ?? false;
        message.showTitle = object.showTitle ?? false;
        return message;
    },
};
messageTypeRegistry.set(CalendarWidgetConfiguration.$type, CalendarWidgetConfiguration);
function createBaseCalendarWidget() {
    return {
        id: "",
        kind: "",
        configuration: undefined,
        googleCalendarId: "",
        requiresSync: false,
        shortName: "",
        styles: undefined,
    };
}
export const CalendarWidget = {
    $type: "devvit.plugin.redditapi.widgets.CalendarWidget",
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.kind !== "") {
            writer.uint32(18).string(message.kind);
        }
        if (message.configuration !== undefined) {
            CalendarWidgetConfiguration.encode(message.configuration, writer.uint32(26).fork()).ldelim();
        }
        if (message.googleCalendarId !== "") {
            writer.uint32(34).string(message.googleCalendarId);
        }
        if (message.requiresSync !== false) {
            writer.uint32(40).bool(message.requiresSync);
        }
        if (message.shortName !== "") {
            writer.uint32(50).string(message.shortName);
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCalendarWidget();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.configuration = CalendarWidgetConfiguration.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.googleCalendarId = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.requiresSync = reader.bool();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            configuration: isSet(object.configuration)
                ? CalendarWidgetConfiguration.fromJSON(object.configuration)
                : undefined,
            googleCalendarId: isSet(object.googleCalendarId) ? globalThis.String(object.googleCalendarId) : "",
            requiresSync: isSet(object.requiresSync) ? globalThis.Boolean(object.requiresSync) : false,
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.configuration !== undefined) {
            obj.configuration = CalendarWidgetConfiguration.toJSON(message.configuration);
        }
        if (message.googleCalendarId !== "") {
            obj.googleCalendarId = message.googleCalendarId;
        }
        if (message.requiresSync !== false) {
            obj.requiresSync = message.requiresSync;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        return obj;
    },
    create(base) {
        return CalendarWidget.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCalendarWidget();
        message.id = object.id ?? "";
        message.kind = object.kind ?? "";
        message.configuration = (object.configuration !== undefined && object.configuration !== null)
            ? CalendarWidgetConfiguration.fromPartial(object.configuration)
            : undefined;
        message.googleCalendarId = object.googleCalendarId ?? "";
        message.requiresSync = object.requiresSync ?? false;
        message.shortName = object.shortName ?? "";
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(CalendarWidget.$type, CalendarWidget);
function createBaseAddCalendarWidgetRequest() {
    return {
        subreddit: "",
        configuration: undefined,
        googleCalendarId: "",
        requiresSync: false,
        shortName: "",
        styles: undefined,
    };
}
export const AddCalendarWidgetRequest = {
    $type: "devvit.plugin.redditapi.widgets.AddCalendarWidgetRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.configuration !== undefined) {
            CalendarWidgetConfiguration.encode(message.configuration, writer.uint32(18).fork()).ldelim();
        }
        if (message.googleCalendarId !== "") {
            writer.uint32(26).string(message.googleCalendarId);
        }
        if (message.requiresSync !== false) {
            writer.uint32(32).bool(message.requiresSync);
        }
        if (message.shortName !== "") {
            writer.uint32(42).string(message.shortName);
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAddCalendarWidgetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.configuration = CalendarWidgetConfiguration.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.googleCalendarId = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.requiresSync = reader.bool();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            configuration: isSet(object.configuration)
                ? CalendarWidgetConfiguration.fromJSON(object.configuration)
                : undefined,
            googleCalendarId: isSet(object.googleCalendarId) ? globalThis.String(object.googleCalendarId) : "",
            requiresSync: isSet(object.requiresSync) ? globalThis.Boolean(object.requiresSync) : false,
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.configuration !== undefined) {
            obj.configuration = CalendarWidgetConfiguration.toJSON(message.configuration);
        }
        if (message.googleCalendarId !== "") {
            obj.googleCalendarId = message.googleCalendarId;
        }
        if (message.requiresSync !== false) {
            obj.requiresSync = message.requiresSync;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        return obj;
    },
    create(base) {
        return AddCalendarWidgetRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddCalendarWidgetRequest();
        message.subreddit = object.subreddit ?? "";
        message.configuration = (object.configuration !== undefined && object.configuration !== null)
            ? CalendarWidgetConfiguration.fromPartial(object.configuration)
            : undefined;
        message.googleCalendarId = object.googleCalendarId ?? "";
        message.requiresSync = object.requiresSync ?? false;
        message.shortName = object.shortName ?? "";
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(AddCalendarWidgetRequest.$type, AddCalendarWidgetRequest);
function createBaseUpdateCalendarWidgetRequest() {
    return {
        subreddit: "",
        id: "",
        configuration: undefined,
        googleCalendarId: "",
        requiresSync: false,
        shortName: "",
        styles: undefined,
    };
}
export const UpdateCalendarWidgetRequest = {
    $type: "devvit.plugin.redditapi.widgets.UpdateCalendarWidgetRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.id !== "") {
            writer.uint32(18).string(message.id);
        }
        if (message.configuration !== undefined) {
            CalendarWidgetConfiguration.encode(message.configuration, writer.uint32(26).fork()).ldelim();
        }
        if (message.googleCalendarId !== "") {
            writer.uint32(34).string(message.googleCalendarId);
        }
        if (message.requiresSync !== false) {
            writer.uint32(40).bool(message.requiresSync);
        }
        if (message.shortName !== "") {
            writer.uint32(50).string(message.shortName);
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateCalendarWidgetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.configuration = CalendarWidgetConfiguration.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.googleCalendarId = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.requiresSync = reader.bool();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            configuration: isSet(object.configuration)
                ? CalendarWidgetConfiguration.fromJSON(object.configuration)
                : undefined,
            googleCalendarId: isSet(object.googleCalendarId) ? globalThis.String(object.googleCalendarId) : "",
            requiresSync: isSet(object.requiresSync) ? globalThis.Boolean(object.requiresSync) : false,
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.configuration !== undefined) {
            obj.configuration = CalendarWidgetConfiguration.toJSON(message.configuration);
        }
        if (message.googleCalendarId !== "") {
            obj.googleCalendarId = message.googleCalendarId;
        }
        if (message.requiresSync !== false) {
            obj.requiresSync = message.requiresSync;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        return obj;
    },
    create(base) {
        return UpdateCalendarWidgetRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateCalendarWidgetRequest();
        message.subreddit = object.subreddit ?? "";
        message.id = object.id ?? "";
        message.configuration = (object.configuration !== undefined && object.configuration !== null)
            ? CalendarWidgetConfiguration.fromPartial(object.configuration)
            : undefined;
        message.googleCalendarId = object.googleCalendarId ?? "";
        message.requiresSync = object.requiresSync ?? false;
        message.shortName = object.shortName ?? "";
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(UpdateCalendarWidgetRequest.$type, UpdateCalendarWidgetRequest);
function createBaseTextAreaWidget() {
    return { id: "", kind: "", shortName: "", text: "", styles: undefined };
}
export const TextAreaWidget = {
    $type: "devvit.plugin.redditapi.widgets.TextAreaWidget",
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.kind !== "") {
            writer.uint32(18).string(message.kind);
        }
        if (message.shortName !== "") {
            writer.uint32(26).string(message.shortName);
        }
        if (message.text !== "") {
            writer.uint32(34).string(message.text);
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTextAreaWidget();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        return obj;
    },
    create(base) {
        return TextAreaWidget.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTextAreaWidget();
        message.id = object.id ?? "";
        message.kind = object.kind ?? "";
        message.shortName = object.shortName ?? "";
        message.text = object.text ?? "";
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(TextAreaWidget.$type, TextAreaWidget);
function createBaseAddTextAreaWidgetRequest() {
    return { subreddit: "", shortName: "", text: "", styles: undefined };
}
export const AddTextAreaWidgetRequest = {
    $type: "devvit.plugin.redditapi.widgets.AddTextAreaWidgetRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.shortName !== "") {
            writer.uint32(18).string(message.shortName);
        }
        if (message.text !== "") {
            writer.uint32(26).string(message.text);
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAddTextAreaWidgetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        return obj;
    },
    create(base) {
        return AddTextAreaWidgetRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddTextAreaWidgetRequest();
        message.subreddit = object.subreddit ?? "";
        message.shortName = object.shortName ?? "";
        message.text = object.text ?? "";
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(AddTextAreaWidgetRequest.$type, AddTextAreaWidgetRequest);
function createBaseUpdateTextAreaWidgetRequest() {
    return { subreddit: "", id: "", shortName: "", text: "", styles: undefined };
}
export const UpdateTextAreaWidgetRequest = {
    $type: "devvit.plugin.redditapi.widgets.UpdateTextAreaWidgetRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.id !== "") {
            writer.uint32(18).string(message.id);
        }
        if (message.shortName !== "") {
            writer.uint32(26).string(message.shortName);
        }
        if (message.text !== "") {
            writer.uint32(34).string(message.text);
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateTextAreaWidgetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        return obj;
    },
    create(base) {
        return UpdateTextAreaWidgetRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateTextAreaWidgetRequest();
        message.subreddit = object.subreddit ?? "";
        message.id = object.id ?? "";
        message.shortName = object.shortName ?? "";
        message.text = object.text ?? "";
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(UpdateTextAreaWidgetRequest.$type, UpdateTextAreaWidgetRequest);
function createBaseWidgetButton() {
    return {
        kind: "",
        text: "",
        url: undefined,
        imageUrl: undefined,
        linkUrl: undefined,
        color: undefined,
        fillColor: undefined,
        textColor: undefined,
        height: undefined,
        width: undefined,
        hoverState: undefined,
    };
}
export const WidgetButton = {
    $type: "devvit.plugin.redditapi.widgets.WidgetButton",
    encode(message, writer = _m0.Writer.create()) {
        if (message.kind !== "") {
            writer.uint32(10).string(message.kind);
        }
        if (message.text !== "") {
            writer.uint32(18).string(message.text);
        }
        if (message.url !== undefined) {
            StringValue.encode({ value: message.url }, writer.uint32(26).fork()).ldelim();
        }
        if (message.imageUrl !== undefined) {
            StringValue.encode({ value: message.imageUrl }, writer.uint32(34).fork()).ldelim();
        }
        if (message.linkUrl !== undefined) {
            StringValue.encode({ value: message.linkUrl }, writer.uint32(42).fork()).ldelim();
        }
        if (message.color !== undefined) {
            StringValue.encode({ value: message.color }, writer.uint32(50).fork()).ldelim();
        }
        if (message.fillColor !== undefined) {
            StringValue.encode({ value: message.fillColor }, writer.uint32(58).fork()).ldelim();
        }
        if (message.textColor !== undefined) {
            StringValue.encode({ value: message.textColor }, writer.uint32(66).fork()).ldelim();
        }
        if (message.height !== undefined) {
            Int32Value.encode({ value: message.height }, writer.uint32(74).fork()).ldelim();
        }
        if (message.width !== undefined) {
            Int32Value.encode({ value: message.width }, writer.uint32(82).fork()).ldelim();
        }
        if (message.hoverState !== undefined) {
            WidgetButton_HoverState.encode(message.hoverState, writer.uint32(90).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWidgetButton();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.url = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.imageUrl = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.linkUrl = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.color = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.fillColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.textColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.height = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.width = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.hoverState = WidgetButton_HoverState.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            url: isSet(object.url) ? String(object.url) : undefined,
            imageUrl: isSet(object.imageUrl) ? String(object.imageUrl) : undefined,
            linkUrl: isSet(object.linkUrl) ? String(object.linkUrl) : undefined,
            color: isSet(object.color) ? String(object.color) : undefined,
            fillColor: isSet(object.fillColor) ? String(object.fillColor) : undefined,
            textColor: isSet(object.textColor) ? String(object.textColor) : undefined,
            height: isSet(object.height) ? Number(object.height) : undefined,
            width: isSet(object.width) ? Number(object.width) : undefined,
            hoverState: isSet(object.hoverState) ? WidgetButton_HoverState.fromJSON(object.hoverState) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.url !== undefined) {
            obj.url = message.url;
        }
        if (message.imageUrl !== undefined) {
            obj.imageUrl = message.imageUrl;
        }
        if (message.linkUrl !== undefined) {
            obj.linkUrl = message.linkUrl;
        }
        if (message.color !== undefined) {
            obj.color = message.color;
        }
        if (message.fillColor !== undefined) {
            obj.fillColor = message.fillColor;
        }
        if (message.textColor !== undefined) {
            obj.textColor = message.textColor;
        }
        if (message.height !== undefined) {
            obj.height = message.height;
        }
        if (message.width !== undefined) {
            obj.width = message.width;
        }
        if (message.hoverState !== undefined) {
            obj.hoverState = WidgetButton_HoverState.toJSON(message.hoverState);
        }
        return obj;
    },
    create(base) {
        return WidgetButton.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWidgetButton();
        message.kind = object.kind ?? "";
        message.text = object.text ?? "";
        message.url = object.url ?? undefined;
        message.imageUrl = object.imageUrl ?? undefined;
        message.linkUrl = object.linkUrl ?? undefined;
        message.color = object.color ?? undefined;
        message.fillColor = object.fillColor ?? undefined;
        message.textColor = object.textColor ?? undefined;
        message.height = object.height ?? undefined;
        message.width = object.width ?? undefined;
        message.hoverState = (object.hoverState !== undefined && object.hoverState !== null)
            ? WidgetButton_HoverState.fromPartial(object.hoverState)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(WidgetButton.$type, WidgetButton);
function createBaseWidgetButton_HoverState() {
    return {
        kind: "",
        color: undefined,
        fillColor: undefined,
        text: undefined,
        textColor: undefined,
        imageUrl: undefined,
        height: undefined,
        width: undefined,
    };
}
export const WidgetButton_HoverState = {
    $type: "devvit.plugin.redditapi.widgets.WidgetButton.HoverState",
    encode(message, writer = _m0.Writer.create()) {
        if (message.kind !== "") {
            writer.uint32(10).string(message.kind);
        }
        if (message.color !== undefined) {
            StringValue.encode({ value: message.color }, writer.uint32(18).fork()).ldelim();
        }
        if (message.fillColor !== undefined) {
            StringValue.encode({ value: message.fillColor }, writer.uint32(26).fork()).ldelim();
        }
        if (message.text !== undefined) {
            StringValue.encode({ value: message.text }, writer.uint32(34).fork()).ldelim();
        }
        if (message.textColor !== undefined) {
            StringValue.encode({ value: message.textColor }, writer.uint32(42).fork()).ldelim();
        }
        if (message.imageUrl !== undefined) {
            StringValue.encode({ value: message.imageUrl }, writer.uint32(50).fork()).ldelim();
        }
        if (message.height !== undefined) {
            Int32Value.encode({ value: message.height }, writer.uint32(58).fork()).ldelim();
        }
        if (message.width !== undefined) {
            Int32Value.encode({ value: message.width }, writer.uint32(66).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWidgetButton_HoverState();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.color = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.fillColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.text = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.textColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.imageUrl = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.height = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.width = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            color: isSet(object.color) ? String(object.color) : undefined,
            fillColor: isSet(object.fillColor) ? String(object.fillColor) : undefined,
            text: isSet(object.text) ? String(object.text) : undefined,
            textColor: isSet(object.textColor) ? String(object.textColor) : undefined,
            imageUrl: isSet(object.imageUrl) ? String(object.imageUrl) : undefined,
            height: isSet(object.height) ? Number(object.height) : undefined,
            width: isSet(object.width) ? Number(object.width) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.color !== undefined) {
            obj.color = message.color;
        }
        if (message.fillColor !== undefined) {
            obj.fillColor = message.fillColor;
        }
        if (message.text !== undefined) {
            obj.text = message.text;
        }
        if (message.textColor !== undefined) {
            obj.textColor = message.textColor;
        }
        if (message.imageUrl !== undefined) {
            obj.imageUrl = message.imageUrl;
        }
        if (message.height !== undefined) {
            obj.height = message.height;
        }
        if (message.width !== undefined) {
            obj.width = message.width;
        }
        return obj;
    },
    create(base) {
        return WidgetButton_HoverState.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWidgetButton_HoverState();
        message.kind = object.kind ?? "";
        message.color = object.color ?? undefined;
        message.fillColor = object.fillColor ?? undefined;
        message.text = object.text ?? undefined;
        message.textColor = object.textColor ?? undefined;
        message.imageUrl = object.imageUrl ?? undefined;
        message.height = object.height ?? undefined;
        message.width = object.width ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(WidgetButton_HoverState.$type, WidgetButton_HoverState);
function createBaseButtonWidget() {
    return { id: "", kind: "", shortName: "", description: "", buttons: [], styles: undefined };
}
export const ButtonWidget = {
    $type: "devvit.plugin.redditapi.widgets.ButtonWidget",
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.kind !== "") {
            writer.uint32(18).string(message.kind);
        }
        if (message.shortName !== "") {
            writer.uint32(26).string(message.shortName);
        }
        if (message.description !== "") {
            writer.uint32(34).string(message.description);
        }
        for (const v of message.buttons) {
            WidgetButton.encode(v, writer.uint32(42).fork()).ldelim();
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseButtonWidget();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.buttons.push(WidgetButton.decode(reader, reader.uint32()));
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            description: isSet(object.description) ? globalThis.String(object.description) : "",
            buttons: globalThis.Array.isArray(object?.buttons)
                ? object.buttons.map((e) => WidgetButton.fromJSON(e))
                : [],
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.description !== "") {
            obj.description = message.description;
        }
        if (message.buttons?.length) {
            obj.buttons = message.buttons.map((e) => WidgetButton.toJSON(e));
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        return obj;
    },
    create(base) {
        return ButtonWidget.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseButtonWidget();
        message.id = object.id ?? "";
        message.kind = object.kind ?? "";
        message.shortName = object.shortName ?? "";
        message.description = object.description ?? "";
        message.buttons = object.buttons?.map((e) => WidgetButton.fromPartial(e)) || [];
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(ButtonWidget.$type, ButtonWidget);
function createBaseAddButtonWidgetRequest() {
    return { subreddit: "", shortName: "", description: "", buttons: [], styles: undefined };
}
export const AddButtonWidgetRequest = {
    $type: "devvit.plugin.redditapi.widgets.AddButtonWidgetRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.shortName !== "") {
            writer.uint32(18).string(message.shortName);
        }
        if (message.description !== "") {
            writer.uint32(26).string(message.description);
        }
        for (const v of message.buttons) {
            WidgetButton.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAddButtonWidgetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.buttons.push(WidgetButton.decode(reader, reader.uint32()));
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            description: isSet(object.description) ? globalThis.String(object.description) : "",
            buttons: globalThis.Array.isArray(object?.buttons)
                ? object.buttons.map((e) => WidgetButton.fromJSON(e))
                : [],
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.description !== "") {
            obj.description = message.description;
        }
        if (message.buttons?.length) {
            obj.buttons = message.buttons.map((e) => WidgetButton.toJSON(e));
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        return obj;
    },
    create(base) {
        return AddButtonWidgetRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddButtonWidgetRequest();
        message.subreddit = object.subreddit ?? "";
        message.shortName = object.shortName ?? "";
        message.description = object.description ?? "";
        message.buttons = object.buttons?.map((e) => WidgetButton.fromPartial(e)) || [];
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(AddButtonWidgetRequest.$type, AddButtonWidgetRequest);
function createBaseUpdateButtonWidgetRequest() {
    return { subreddit: "", id: "", shortName: "", description: "", buttons: [], styles: undefined };
}
export const UpdateButtonWidgetRequest = {
    $type: "devvit.plugin.redditapi.widgets.UpdateButtonWidgetRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.id !== "") {
            writer.uint32(18).string(message.id);
        }
        if (message.shortName !== "") {
            writer.uint32(26).string(message.shortName);
        }
        if (message.description !== "") {
            writer.uint32(34).string(message.description);
        }
        for (const v of message.buttons) {
            WidgetButton.encode(v, writer.uint32(42).fork()).ldelim();
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateButtonWidgetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.buttons.push(WidgetButton.decode(reader, reader.uint32()));
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            description: isSet(object.description) ? globalThis.String(object.description) : "",
            buttons: globalThis.Array.isArray(object?.buttons)
                ? object.buttons.map((e) => WidgetButton.fromJSON(e))
                : [],
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.description !== "") {
            obj.description = message.description;
        }
        if (message.buttons?.length) {
            obj.buttons = message.buttons.map((e) => WidgetButton.toJSON(e));
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        return obj;
    },
    create(base) {
        return UpdateButtonWidgetRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateButtonWidgetRequest();
        message.subreddit = object.subreddit ?? "";
        message.id = object.id ?? "";
        message.shortName = object.shortName ?? "";
        message.description = object.description ?? "";
        message.buttons = object.buttons?.map((e) => WidgetButton.fromPartial(e)) || [];
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(UpdateButtonWidgetRequest.$type, UpdateButtonWidgetRequest);
function createBaseCommunityListWidget() {
    return { id: "", kind: "", shortName: "", data: [], styles: undefined };
}
export const CommunityListWidget = {
    $type: "devvit.plugin.redditapi.widgets.CommunityListWidget",
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.kind !== "") {
            writer.uint32(18).string(message.kind);
        }
        if (message.shortName !== "") {
            writer.uint32(26).string(message.shortName);
        }
        for (const v of message.data) {
            CommunityListWidget_CommunityData.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommunityListWidget();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.data.push(CommunityListWidget_CommunityData.decode(reader, reader.uint32()));
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            data: globalThis.Array.isArray(object?.data)
                ? object.data.map((e) => CommunityListWidget_CommunityData.fromJSON(e))
                : [],
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.data?.length) {
            obj.data = message.data.map((e) => CommunityListWidget_CommunityData.toJSON(e));
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        return obj;
    },
    create(base) {
        return CommunityListWidget.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCommunityListWidget();
        message.id = object.id ?? "";
        message.kind = object.kind ?? "";
        message.shortName = object.shortName ?? "";
        message.data = object.data?.map((e) => CommunityListWidget_CommunityData.fromPartial(e)) || [];
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(CommunityListWidget.$type, CommunityListWidget);
function createBaseCommunityListWidget_CommunityData() {
    return {
        communityIcon: "",
        iconUrl: "",
        isNsfw: false,
        isSubscribed: false,
        name: "",
        prefixedName: "",
        primaryColor: "",
        subscribers: 0,
        type: "",
    };
}
export const CommunityListWidget_CommunityData = {
    $type: "devvit.plugin.redditapi.widgets.CommunityListWidget.CommunityData",
    encode(message, writer = _m0.Writer.create()) {
        if (message.communityIcon !== "") {
            writer.uint32(10).string(message.communityIcon);
        }
        if (message.iconUrl !== "") {
            writer.uint32(18).string(message.iconUrl);
        }
        if (message.isNsfw !== false) {
            writer.uint32(24).bool(message.isNsfw);
        }
        if (message.isSubscribed !== false) {
            writer.uint32(32).bool(message.isSubscribed);
        }
        if (message.name !== "") {
            writer.uint32(42).string(message.name);
        }
        if (message.prefixedName !== "") {
            writer.uint32(50).string(message.prefixedName);
        }
        if (message.primaryColor !== "") {
            writer.uint32(58).string(message.primaryColor);
        }
        if (message.subscribers !== 0) {
            writer.uint32(64).int32(message.subscribers);
        }
        if (message.type !== "") {
            writer.uint32(74).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommunityListWidget_CommunityData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.communityIcon = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.iconUrl = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.isNsfw = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.isSubscribed = reader.bool();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.prefixedName = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.primaryColor = reader.string();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.subscribers = reader.int32();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.type = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            communityIcon: isSet(object.communityIcon) ? globalThis.String(object.communityIcon) : "",
            iconUrl: isSet(object.iconUrl) ? globalThis.String(object.iconUrl) : "",
            isNsfw: isSet(object.isNsfw) ? globalThis.Boolean(object.isNsfw) : false,
            isSubscribed: isSet(object.isSubscribed) ? globalThis.Boolean(object.isSubscribed) : false,
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            prefixedName: isSet(object.prefixedName) ? globalThis.String(object.prefixedName) : "",
            primaryColor: isSet(object.primaryColor) ? globalThis.String(object.primaryColor) : "",
            subscribers: isSet(object.subscribers) ? globalThis.Number(object.subscribers) : 0,
            type: isSet(object.type) ? globalThis.String(object.type) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.communityIcon !== "") {
            obj.communityIcon = message.communityIcon;
        }
        if (message.iconUrl !== "") {
            obj.iconUrl = message.iconUrl;
        }
        if (message.isNsfw !== false) {
            obj.isNsfw = message.isNsfw;
        }
        if (message.isSubscribed !== false) {
            obj.isSubscribed = message.isSubscribed;
        }
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.prefixedName !== "") {
            obj.prefixedName = message.prefixedName;
        }
        if (message.primaryColor !== "") {
            obj.primaryColor = message.primaryColor;
        }
        if (message.subscribers !== 0) {
            obj.subscribers = Math.round(message.subscribers);
        }
        if (message.type !== "") {
            obj.type = message.type;
        }
        return obj;
    },
    create(base) {
        return CommunityListWidget_CommunityData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCommunityListWidget_CommunityData();
        message.communityIcon = object.communityIcon ?? "";
        message.iconUrl = object.iconUrl ?? "";
        message.isNsfw = object.isNsfw ?? false;
        message.isSubscribed = object.isSubscribed ?? false;
        message.name = object.name ?? "";
        message.prefixedName = object.prefixedName ?? "";
        message.primaryColor = object.primaryColor ?? "";
        message.subscribers = object.subscribers ?? 0;
        message.type = object.type ?? "";
        return message;
    },
};
messageTypeRegistry.set(CommunityListWidget_CommunityData.$type, CommunityListWidget_CommunityData);
function createBaseAddCommunityListWidgetRequest() {
    return { subreddit: "", shortName: "", data: [], styles: undefined };
}
export const AddCommunityListWidgetRequest = {
    $type: "devvit.plugin.redditapi.widgets.AddCommunityListWidgetRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.shortName !== "") {
            writer.uint32(18).string(message.shortName);
        }
        for (const v of message.data) {
            writer.uint32(26).string(v);
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAddCommunityListWidgetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.data.push(reader.string());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            data: globalThis.Array.isArray(object?.data) ? object.data.map((e) => globalThis.String(e)) : [],
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.data?.length) {
            obj.data = message.data;
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        return obj;
    },
    create(base) {
        return AddCommunityListWidgetRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddCommunityListWidgetRequest();
        message.subreddit = object.subreddit ?? "";
        message.shortName = object.shortName ?? "";
        message.data = object.data?.map((e) => e) || [];
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(AddCommunityListWidgetRequest.$type, AddCommunityListWidgetRequest);
function createBaseUpdateCommunityListWidgetRequest() {
    return { subreddit: "", id: "", shortName: "", data: [], styles: undefined };
}
export const UpdateCommunityListWidgetRequest = {
    $type: "devvit.plugin.redditapi.widgets.UpdateCommunityListWidgetRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.id !== "") {
            writer.uint32(18).string(message.id);
        }
        if (message.shortName !== "") {
            writer.uint32(26).string(message.shortName);
        }
        for (const v of message.data) {
            writer.uint32(34).string(v);
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateCommunityListWidgetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.data.push(reader.string());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            data: globalThis.Array.isArray(object?.data) ? object.data.map((e) => globalThis.String(e)) : [],
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.data?.length) {
            obj.data = message.data;
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        return obj;
    },
    create(base) {
        return UpdateCommunityListWidgetRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateCommunityListWidgetRequest();
        message.subreddit = object.subreddit ?? "";
        message.id = object.id ?? "";
        message.shortName = object.shortName ?? "";
        message.data = object.data?.map((e) => e) || [];
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(UpdateCommunityListWidgetRequest.$type, UpdateCommunityListWidgetRequest);
function createBaseUpdateCommunityListWidgetResponse() {
    return { kind: "", shortName: "", data: [], styles: undefined };
}
export const UpdateCommunityListWidgetResponse = {
    $type: "devvit.plugin.redditapi.widgets.UpdateCommunityListWidgetResponse",
    encode(message, writer = _m0.Writer.create()) {
        if (message.kind !== "") {
            writer.uint32(10).string(message.kind);
        }
        if (message.shortName !== "") {
            writer.uint32(18).string(message.shortName);
        }
        for (const v of message.data) {
            writer.uint32(26).string(v);
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateCommunityListWidgetResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.data.push(reader.string());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            data: globalThis.Array.isArray(object?.data) ? object.data.map((e) => globalThis.String(e)) : [],
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.data?.length) {
            obj.data = message.data;
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        return obj;
    },
    create(base) {
        return UpdateCommunityListWidgetResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateCommunityListWidgetResponse();
        message.kind = object.kind ?? "";
        message.shortName = object.shortName ?? "";
        message.data = object.data?.map((e) => e) || [];
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(UpdateCommunityListWidgetResponse.$type, UpdateCommunityListWidgetResponse);
function createBasePostFlairWidget() {
    return { id: "", kind: "", display: "", order: [], shortName: "", styles: undefined, subreddit: undefined };
}
export const PostFlairWidget = {
    $type: "devvit.plugin.redditapi.widgets.PostFlairWidget",
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.kind !== "") {
            writer.uint32(18).string(message.kind);
        }
        if (message.display !== "") {
            writer.uint32(26).string(message.display);
        }
        for (const v of message.order) {
            writer.uint32(34).string(v);
        }
        if (message.shortName !== "") {
            writer.uint32(42).string(message.shortName);
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(50).fork()).ldelim();
        }
        if (message.subreddit !== undefined) {
            StringValue.encode({ value: message.subreddit }, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePostFlairWidget();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.display = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.order.push(reader.string());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.subreddit = StringValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            display: isSet(object.display) ? globalThis.String(object.display) : "",
            order: globalThis.Array.isArray(object?.order) ? object.order.map((e) => globalThis.String(e)) : [],
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
            subreddit: isSet(object.subreddit) ? String(object.subreddit) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.display !== "") {
            obj.display = message.display;
        }
        if (message.order?.length) {
            obj.order = message.order;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        if (message.subreddit !== undefined) {
            obj.subreddit = message.subreddit;
        }
        return obj;
    },
    create(base) {
        return PostFlairWidget.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePostFlairWidget();
        message.id = object.id ?? "";
        message.kind = object.kind ?? "";
        message.display = object.display ?? "";
        message.order = object.order?.map((e) => e) || [];
        message.shortName = object.shortName ?? "";
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        message.subreddit = object.subreddit ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(PostFlairWidget.$type, PostFlairWidget);
function createBaseAddPostFlairWidgetRequest() {
    return { subreddit: "", display: "", order: [], shortName: "", styles: undefined };
}
export const AddPostFlairWidgetRequest = {
    $type: "devvit.plugin.redditapi.widgets.AddPostFlairWidgetRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.display !== "") {
            writer.uint32(18).string(message.display);
        }
        for (const v of message.order) {
            writer.uint32(26).string(v);
        }
        if (message.shortName !== "") {
            writer.uint32(34).string(message.shortName);
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAddPostFlairWidgetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.display = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.order.push(reader.string());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            display: isSet(object.display) ? globalThis.String(object.display) : "",
            order: globalThis.Array.isArray(object?.order) ? object.order.map((e) => globalThis.String(e)) : [],
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.display !== "") {
            obj.display = message.display;
        }
        if (message.order?.length) {
            obj.order = message.order;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        return obj;
    },
    create(base) {
        return AddPostFlairWidgetRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddPostFlairWidgetRequest();
        message.subreddit = object.subreddit ?? "";
        message.display = object.display ?? "";
        message.order = object.order?.map((e) => e) || [];
        message.shortName = object.shortName ?? "";
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(AddPostFlairWidgetRequest.$type, AddPostFlairWidgetRequest);
function createBaseUpdatePostFlairWidgetRequest() {
    return { subreddit: "", id: "", display: "", order: [], shortName: "", styles: undefined };
}
export const UpdatePostFlairWidgetRequest = {
    $type: "devvit.plugin.redditapi.widgets.UpdatePostFlairWidgetRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.id !== "") {
            writer.uint32(18).string(message.id);
        }
        if (message.display !== "") {
            writer.uint32(26).string(message.display);
        }
        for (const v of message.order) {
            writer.uint32(34).string(v);
        }
        if (message.shortName !== "") {
            writer.uint32(42).string(message.shortName);
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdatePostFlairWidgetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.display = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.order.push(reader.string());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            display: isSet(object.display) ? globalThis.String(object.display) : "",
            order: globalThis.Array.isArray(object?.order) ? object.order.map((e) => globalThis.String(e)) : [],
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.display !== "") {
            obj.display = message.display;
        }
        if (message.order?.length) {
            obj.order = message.order;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        return obj;
    },
    create(base) {
        return UpdatePostFlairWidgetRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdatePostFlairWidgetRequest();
        message.subreddit = object.subreddit ?? "";
        message.id = object.id ?? "";
        message.display = object.display ?? "";
        message.order = object.order?.map((e) => e) || [];
        message.shortName = object.shortName ?? "";
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(UpdatePostFlairWidgetRequest.$type, UpdatePostFlairWidgetRequest);
function createBaseDeleteWidgetRequest() {
    return { id: "", subreddit: "" };
}
export const DeleteWidgetRequest = {
    $type: "devvit.plugin.redditapi.widgets.DeleteWidgetRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.subreddit !== "") {
            writer.uint32(18).string(message.subreddit);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeleteWidgetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        return obj;
    },
    create(base) {
        return DeleteWidgetRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDeleteWidgetRequest();
        message.id = object.id ?? "";
        message.subreddit = object.subreddit ?? "";
        return message;
    },
};
messageTypeRegistry.set(DeleteWidgetRequest.$type, DeleteWidgetRequest);
function createBaseGetWidgetsRequest() {
    return { subreddit: "", progressiveImages: undefined };
}
export const GetWidgetsRequest = {
    $type: "devvit.plugin.redditapi.widgets.GetWidgetsRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.progressiveImages !== undefined) {
            BoolValue.encode({ value: message.progressiveImages }, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetWidgetsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.progressiveImages = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            progressiveImages: isSet(object.progressiveImages) ? Boolean(object.progressiveImages) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.progressiveImages !== undefined) {
            obj.progressiveImages = message.progressiveImages;
        }
        return obj;
    },
    create(base) {
        return GetWidgetsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetWidgetsRequest();
        message.subreddit = object.subreddit ?? "";
        message.progressiveImages = object.progressiveImages ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(GetWidgetsRequest.$type, GetWidgetsRequest);
function createBaseGetWidgetsResponse() {
    return { layout: undefined, items: {} };
}
export const GetWidgetsResponse = {
    $type: "devvit.plugin.redditapi.widgets.GetWidgetsResponse",
    encode(message, writer = _m0.Writer.create()) {
        if (message.layout !== undefined) {
            GetWidgetsResponse_Layout.encode(message.layout, writer.uint32(10).fork()).ldelim();
        }
        Object.entries(message.items).forEach(([key, value]) => {
            GetWidgetsResponse_ItemsEntry.encode({ key: key, value }, writer.uint32(18).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetWidgetsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.layout = GetWidgetsResponse_Layout.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    const entry2 = GetWidgetsResponse_ItemsEntry.decode(reader, reader.uint32());
                    if (entry2.value !== undefined) {
                        message.items[entry2.key] = entry2.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            layout: isSet(object.layout) ? GetWidgetsResponse_Layout.fromJSON(object.layout) : undefined,
            items: isObject(object.items)
                ? Object.entries(object.items).reduce((acc, [key, value]) => {
                    acc[key] = GetWidgetsResponse_WidgetItem.fromJSON(value);
                    return acc;
                }, {})
                : {},
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.layout !== undefined) {
            obj.layout = GetWidgetsResponse_Layout.toJSON(message.layout);
        }
        if (message.items) {
            const entries = Object.entries(message.items);
            if (entries.length > 0) {
                obj.items = {};
                entries.forEach(([k, v]) => {
                    obj.items[k] = GetWidgetsResponse_WidgetItem.toJSON(v);
                });
            }
        }
        return obj;
    },
    create(base) {
        return GetWidgetsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetWidgetsResponse();
        message.layout = (object.layout !== undefined && object.layout !== null)
            ? GetWidgetsResponse_Layout.fromPartial(object.layout)
            : undefined;
        message.items = Object.entries(object.items ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = GetWidgetsResponse_WidgetItem.fromPartial(value);
            }
            return acc;
        }, {});
        return message;
    },
};
messageTypeRegistry.set(GetWidgetsResponse.$type, GetWidgetsResponse);
function createBaseGetWidgetsResponse_WidgetOrdering() {
    return { order: [] };
}
export const GetWidgetsResponse_WidgetOrdering = {
    $type: "devvit.plugin.redditapi.widgets.GetWidgetsResponse.WidgetOrdering",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.order) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetWidgetsResponse_WidgetOrdering();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.order.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { order: globalThis.Array.isArray(object?.order) ? object.order.map((e) => globalThis.String(e)) : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.order?.length) {
            obj.order = message.order;
        }
        return obj;
    },
    create(base) {
        return GetWidgetsResponse_WidgetOrdering.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetWidgetsResponse_WidgetOrdering();
        message.order = object.order?.map((e) => e) || [];
        return message;
    },
};
messageTypeRegistry.set(GetWidgetsResponse_WidgetOrdering.$type, GetWidgetsResponse_WidgetOrdering);
function createBaseGetWidgetsResponse_Layout() {
    return { idCardWidget: "", topbar: undefined, sidebar: undefined, moderatorWidget: "" };
}
export const GetWidgetsResponse_Layout = {
    $type: "devvit.plugin.redditapi.widgets.GetWidgetsResponse.Layout",
    encode(message, writer = _m0.Writer.create()) {
        if (message.idCardWidget !== "") {
            writer.uint32(10).string(message.idCardWidget);
        }
        if (message.topbar !== undefined) {
            GetWidgetsResponse_WidgetOrdering.encode(message.topbar, writer.uint32(18).fork()).ldelim();
        }
        if (message.sidebar !== undefined) {
            GetWidgetsResponse_WidgetOrdering.encode(message.sidebar, writer.uint32(26).fork()).ldelim();
        }
        if (message.moderatorWidget !== "") {
            writer.uint32(34).string(message.moderatorWidget);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetWidgetsResponse_Layout();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.idCardWidget = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.topbar = GetWidgetsResponse_WidgetOrdering.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.sidebar = GetWidgetsResponse_WidgetOrdering.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.moderatorWidget = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            idCardWidget: isSet(object.idCardWidget) ? globalThis.String(object.idCardWidget) : "",
            topbar: isSet(object.topbar) ? GetWidgetsResponse_WidgetOrdering.fromJSON(object.topbar) : undefined,
            sidebar: isSet(object.sidebar) ? GetWidgetsResponse_WidgetOrdering.fromJSON(object.sidebar) : undefined,
            moderatorWidget: isSet(object.moderatorWidget) ? globalThis.String(object.moderatorWidget) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.idCardWidget !== "") {
            obj.idCardWidget = message.idCardWidget;
        }
        if (message.topbar !== undefined) {
            obj.topbar = GetWidgetsResponse_WidgetOrdering.toJSON(message.topbar);
        }
        if (message.sidebar !== undefined) {
            obj.sidebar = GetWidgetsResponse_WidgetOrdering.toJSON(message.sidebar);
        }
        if (message.moderatorWidget !== "") {
            obj.moderatorWidget = message.moderatorWidget;
        }
        return obj;
    },
    create(base) {
        return GetWidgetsResponse_Layout.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetWidgetsResponse_Layout();
        message.idCardWidget = object.idCardWidget ?? "";
        message.topbar = (object.topbar !== undefined && object.topbar !== null)
            ? GetWidgetsResponse_WidgetOrdering.fromPartial(object.topbar)
            : undefined;
        message.sidebar = (object.sidebar !== undefined && object.sidebar !== null)
            ? GetWidgetsResponse_WidgetOrdering.fromPartial(object.sidebar)
            : undefined;
        message.moderatorWidget = object.moderatorWidget ?? "";
        return message;
    },
};
messageTypeRegistry.set(GetWidgetsResponse_Layout.$type, GetWidgetsResponse_Layout);
function createBaseGetWidgetsResponse_WidgetItem() {
    return {
        id: "",
        kind: "",
        styles: undefined,
        shortName: "",
        description: undefined,
        data: [],
        buttons: [],
        subscribersCount: undefined,
        currentlyViewingText: undefined,
        currentlyViewingCount: undefined,
        subscribersText: undefined,
        showWiki: undefined,
        templates: {},
        display: undefined,
        order: [],
        mods: [],
        totalMods: undefined,
        googleCalendarId: undefined,
        requiresSync: undefined,
        configuration: undefined,
        text: undefined,
        css: undefined,
        stylesheetUrl: undefined,
        height: undefined,
        imageData: [],
    };
}
export const GetWidgetsResponse_WidgetItem = {
    $type: "devvit.plugin.redditapi.widgets.GetWidgetsResponse.WidgetItem",
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.kind !== "") {
            writer.uint32(18).string(message.kind);
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(26).fork()).ldelim();
        }
        if (message.shortName !== "") {
            writer.uint32(34).string(message.shortName);
        }
        if (message.description !== undefined) {
            StringValue.encode({ value: message.description }, writer.uint32(42).fork()).ldelim();
        }
        for (const v of message.data) {
            GetWidgetsResponse_WidgetItem_Data.encode(v, writer.uint32(50).fork()).ldelim();
        }
        for (const v of message.buttons) {
            WidgetButton.encode(v, writer.uint32(58).fork()).ldelim();
        }
        if (message.subscribersCount !== undefined) {
            Int64Value.encode({ value: message.subscribersCount }, writer.uint32(66).fork()).ldelim();
        }
        if (message.currentlyViewingText !== undefined) {
            StringValue.encode({ value: message.currentlyViewingText }, writer.uint32(74).fork()).ldelim();
        }
        if (message.currentlyViewingCount !== undefined) {
            Int64Value.encode({ value: message.currentlyViewingCount }, writer.uint32(82).fork()).ldelim();
        }
        if (message.subscribersText !== undefined) {
            StringValue.encode({ value: message.subscribersText }, writer.uint32(90).fork()).ldelim();
        }
        if (message.showWiki !== undefined) {
            BoolValue.encode({ value: message.showWiki }, writer.uint32(98).fork()).ldelim();
        }
        Object.entries(message.templates).forEach(([key, value]) => {
            GetWidgetsResponse_WidgetItem_TemplatesEntry.encode({ key: key, value }, writer.uint32(106).fork())
                .ldelim();
        });
        if (message.display !== undefined) {
            StringValue.encode({ value: message.display }, writer.uint32(114).fork()).ldelim();
        }
        for (const v of message.order) {
            writer.uint32(122).string(v);
        }
        for (const v of message.mods) {
            GetWidgetsResponse_WidgetItem_Moderator.encode(v, writer.uint32(130).fork()).ldelim();
        }
        if (message.totalMods !== undefined) {
            Int64Value.encode({ value: message.totalMods }, writer.uint32(138).fork()).ldelim();
        }
        if (message.googleCalendarId !== undefined) {
            StringValue.encode({ value: message.googleCalendarId }, writer.uint32(146).fork()).ldelim();
        }
        if (message.requiresSync !== undefined) {
            BoolValue.encode({ value: message.requiresSync }, writer.uint32(154).fork()).ldelim();
        }
        if (message.configuration !== undefined) {
            CalendarWidgetConfiguration.encode(message.configuration, writer.uint32(162).fork()).ldelim();
        }
        if (message.text !== undefined) {
            StringValue.encode({ value: message.text }, writer.uint32(170).fork()).ldelim();
        }
        if (message.css !== undefined) {
            StringValue.encode({ value: message.css }, writer.uint32(178).fork()).ldelim();
        }
        if (message.stylesheetUrl !== undefined) {
            StringValue.encode({ value: message.stylesheetUrl }, writer.uint32(186).fork()).ldelim();
        }
        if (message.height !== undefined) {
            Int64Value.encode({ value: message.height }, writer.uint32(194).fork()).ldelim();
        }
        for (const v of message.imageData) {
            WidgetImage.encode(v, writer.uint32(202).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetWidgetsResponse_WidgetItem();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.description = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.data.push(GetWidgetsResponse_WidgetItem_Data.decode(reader, reader.uint32()));
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.buttons.push(WidgetButton.decode(reader, reader.uint32()));
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.subscribersCount = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.currentlyViewingText = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.currentlyViewingCount = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.subscribersText = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.showWiki = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    const entry13 = GetWidgetsResponse_WidgetItem_TemplatesEntry.decode(reader, reader.uint32());
                    if (entry13.value !== undefined) {
                        message.templates[entry13.key] = entry13.value;
                    }
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.display = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.order.push(reader.string());
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.mods.push(GetWidgetsResponse_WidgetItem_Moderator.decode(reader, reader.uint32()));
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.totalMods = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.googleCalendarId = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.requiresSync = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.configuration = CalendarWidgetConfiguration.decode(reader, reader.uint32());
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.text = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.css = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 23:
                    if (tag !== 186) {
                        break;
                    }
                    message.stylesheetUrl = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 24:
                    if (tag !== 194) {
                        break;
                    }
                    message.height = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 25:
                    if (tag !== 202) {
                        break;
                    }
                    message.imageData.push(WidgetImage.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            description: isSet(object.description) ? String(object.description) : undefined,
            data: globalThis.Array.isArray(object?.data)
                ? object.data.map((e) => GetWidgetsResponse_WidgetItem_Data.fromJSON(e))
                : [],
            buttons: globalThis.Array.isArray(object?.buttons)
                ? object.buttons.map((e) => WidgetButton.fromJSON(e))
                : [],
            subscribersCount: isSet(object.subscribersCount) ? Number(object.subscribersCount) : undefined,
            currentlyViewingText: isSet(object.currentlyViewingText) ? String(object.currentlyViewingText) : undefined,
            currentlyViewingCount: isSet(object.currentlyViewingCount) ? Number(object.currentlyViewingCount) : undefined,
            subscribersText: isSet(object.subscribersText) ? String(object.subscribersText) : undefined,
            showWiki: isSet(object.showWiki) ? Boolean(object.showWiki) : undefined,
            templates: isObject(object.templates)
                ? Object.entries(object.templates).reduce((acc, [key, value]) => {
                    acc[key] = GetWidgetsResponse_WidgetItem_PostFlairTemplate.fromJSON(value);
                    return acc;
                }, {})
                : {},
            display: isSet(object.display) ? String(object.display) : undefined,
            order: globalThis.Array.isArray(object?.order) ? object.order.map((e) => globalThis.String(e)) : [],
            mods: globalThis.Array.isArray(object?.mods)
                ? object.mods.map((e) => GetWidgetsResponse_WidgetItem_Moderator.fromJSON(e))
                : [],
            totalMods: isSet(object.totalMods) ? Number(object.totalMods) : undefined,
            googleCalendarId: isSet(object.googleCalendarId) ? String(object.googleCalendarId) : undefined,
            requiresSync: isSet(object.requiresSync) ? Boolean(object.requiresSync) : undefined,
            configuration: isSet(object.configuration)
                ? CalendarWidgetConfiguration.fromJSON(object.configuration)
                : undefined,
            text: isSet(object.text) ? String(object.text) : undefined,
            css: isSet(object.css) ? String(object.css) : undefined,
            stylesheetUrl: isSet(object.stylesheetUrl) ? String(object.stylesheetUrl) : undefined,
            height: isSet(object.height) ? Number(object.height) : undefined,
            imageData: globalThis.Array.isArray(object?.imageData)
                ? object.imageData.map((e) => WidgetImage.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.description !== undefined) {
            obj.description = message.description;
        }
        if (message.data?.length) {
            obj.data = message.data.map((e) => GetWidgetsResponse_WidgetItem_Data.toJSON(e));
        }
        if (message.buttons?.length) {
            obj.buttons = message.buttons.map((e) => WidgetButton.toJSON(e));
        }
        if (message.subscribersCount !== undefined) {
            obj.subscribersCount = message.subscribersCount;
        }
        if (message.currentlyViewingText !== undefined) {
            obj.currentlyViewingText = message.currentlyViewingText;
        }
        if (message.currentlyViewingCount !== undefined) {
            obj.currentlyViewingCount = message.currentlyViewingCount;
        }
        if (message.subscribersText !== undefined) {
            obj.subscribersText = message.subscribersText;
        }
        if (message.showWiki !== undefined) {
            obj.showWiki = message.showWiki;
        }
        if (message.templates) {
            const entries = Object.entries(message.templates);
            if (entries.length > 0) {
                obj.templates = {};
                entries.forEach(([k, v]) => {
                    obj.templates[k] = GetWidgetsResponse_WidgetItem_PostFlairTemplate.toJSON(v);
                });
            }
        }
        if (message.display !== undefined) {
            obj.display = message.display;
        }
        if (message.order?.length) {
            obj.order = message.order;
        }
        if (message.mods?.length) {
            obj.mods = message.mods.map((e) => GetWidgetsResponse_WidgetItem_Moderator.toJSON(e));
        }
        if (message.totalMods !== undefined) {
            obj.totalMods = message.totalMods;
        }
        if (message.googleCalendarId !== undefined) {
            obj.googleCalendarId = message.googleCalendarId;
        }
        if (message.requiresSync !== undefined) {
            obj.requiresSync = message.requiresSync;
        }
        if (message.configuration !== undefined) {
            obj.configuration = CalendarWidgetConfiguration.toJSON(message.configuration);
        }
        if (message.text !== undefined) {
            obj.text = message.text;
        }
        if (message.css !== undefined) {
            obj.css = message.css;
        }
        if (message.stylesheetUrl !== undefined) {
            obj.stylesheetUrl = message.stylesheetUrl;
        }
        if (message.height !== undefined) {
            obj.height = message.height;
        }
        if (message.imageData?.length) {
            obj.imageData = message.imageData.map((e) => WidgetImage.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return GetWidgetsResponse_WidgetItem.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetWidgetsResponse_WidgetItem();
        message.id = object.id ?? "";
        message.kind = object.kind ?? "";
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        message.shortName = object.shortName ?? "";
        message.description = object.description ?? undefined;
        message.data = object.data?.map((e) => GetWidgetsResponse_WidgetItem_Data.fromPartial(e)) || [];
        message.buttons = object.buttons?.map((e) => WidgetButton.fromPartial(e)) || [];
        message.subscribersCount = object.subscribersCount ?? undefined;
        message.currentlyViewingText = object.currentlyViewingText ?? undefined;
        message.currentlyViewingCount = object.currentlyViewingCount ?? undefined;
        message.subscribersText = object.subscribersText ?? undefined;
        message.showWiki = object.showWiki ?? undefined;
        message.templates = Object.entries(object.templates ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = GetWidgetsResponse_WidgetItem_PostFlairTemplate.fromPartial(value);
            }
            return acc;
        }, {});
        message.display = object.display ?? undefined;
        message.order = object.order?.map((e) => e) || [];
        message.mods = object.mods?.map((e) => GetWidgetsResponse_WidgetItem_Moderator.fromPartial(e)) || [];
        message.totalMods = object.totalMods ?? undefined;
        message.googleCalendarId = object.googleCalendarId ?? undefined;
        message.requiresSync = object.requiresSync ?? undefined;
        message.configuration = (object.configuration !== undefined && object.configuration !== null)
            ? CalendarWidgetConfiguration.fromPartial(object.configuration)
            : undefined;
        message.text = object.text ?? undefined;
        message.css = object.css ?? undefined;
        message.stylesheetUrl = object.stylesheetUrl ?? undefined;
        message.height = object.height ?? undefined;
        message.imageData = object.imageData?.map((e) => WidgetImage.fromPartial(e)) || [];
        return message;
    },
};
messageTypeRegistry.set(GetWidgetsResponse_WidgetItem.$type, GetWidgetsResponse_WidgetItem);
function createBaseGetWidgetsResponse_WidgetItem_Data() {
    return {
        url: undefined,
        linkUrl: undefined,
        height: undefined,
        width: undefined,
        iconUrl: undefined,
        name: undefined,
        prefixedName: undefined,
        isSubscribed: undefined,
        type: undefined,
        subscribers: undefined,
        communityIcon: undefined,
        isNsfw: undefined,
        text: undefined,
        children: [],
    };
}
export const GetWidgetsResponse_WidgetItem_Data = {
    $type: "devvit.plugin.redditapi.widgets.GetWidgetsResponse.WidgetItem.Data",
    encode(message, writer = _m0.Writer.create()) {
        if (message.url !== undefined) {
            StringValue.encode({ value: message.url }, writer.uint32(10).fork()).ldelim();
        }
        if (message.linkUrl !== undefined) {
            StringValue.encode({ value: message.linkUrl }, writer.uint32(18).fork()).ldelim();
        }
        if (message.height !== undefined) {
            Int32Value.encode({ value: message.height }, writer.uint32(26).fork()).ldelim();
        }
        if (message.width !== undefined) {
            Int32Value.encode({ value: message.width }, writer.uint32(34).fork()).ldelim();
        }
        if (message.iconUrl !== undefined) {
            StringValue.encode({ value: message.iconUrl }, writer.uint32(42).fork()).ldelim();
        }
        if (message.name !== undefined) {
            StringValue.encode({ value: message.name }, writer.uint32(50).fork()).ldelim();
        }
        if (message.prefixedName !== undefined) {
            StringValue.encode({ value: message.prefixedName }, writer.uint32(58).fork()).ldelim();
        }
        if (message.isSubscribed !== undefined) {
            BoolValue.encode({ value: message.isSubscribed }, writer.uint32(66).fork()).ldelim();
        }
        if (message.type !== undefined) {
            StringValue.encode({ value: message.type }, writer.uint32(74).fork()).ldelim();
        }
        if (message.subscribers !== undefined) {
            Int64Value.encode({ value: message.subscribers }, writer.uint32(82).fork()).ldelim();
        }
        if (message.communityIcon !== undefined) {
            StringValue.encode({ value: message.communityIcon }, writer.uint32(90).fork()).ldelim();
        }
        if (message.isNsfw !== undefined) {
            BoolValue.encode({ value: message.isNsfw }, writer.uint32(98).fork()).ldelim();
        }
        if (message.text !== undefined) {
            StringValue.encode({ value: message.text }, writer.uint32(106).fork()).ldelim();
        }
        for (const v of message.children) {
            MenuWidgetItem.encode(v, writer.uint32(114).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetWidgetsResponse_WidgetItem_Data();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.url = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.linkUrl = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.height = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.width = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.iconUrl = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.name = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.prefixedName = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.isSubscribed = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.type = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.subscribers = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.communityIcon = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.isNsfw = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.text = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.children.push(MenuWidgetItem.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            url: isSet(object.url) ? String(object.url) : undefined,
            linkUrl: isSet(object.linkUrl) ? String(object.linkUrl) : undefined,
            height: isSet(object.height) ? Number(object.height) : undefined,
            width: isSet(object.width) ? Number(object.width) : undefined,
            iconUrl: isSet(object.iconUrl) ? String(object.iconUrl) : undefined,
            name: isSet(object.name) ? String(object.name) : undefined,
            prefixedName: isSet(object.prefixedName) ? String(object.prefixedName) : undefined,
            isSubscribed: isSet(object.isSubscribed) ? Boolean(object.isSubscribed) : undefined,
            type: isSet(object.type) ? String(object.type) : undefined,
            subscribers: isSet(object.subscribers) ? Number(object.subscribers) : undefined,
            communityIcon: isSet(object.communityIcon) ? String(object.communityIcon) : undefined,
            isNsfw: isSet(object.isNsfw) ? Boolean(object.isNsfw) : undefined,
            text: isSet(object.text) ? String(object.text) : undefined,
            children: globalThis.Array.isArray(object?.children)
                ? object.children.map((e) => MenuWidgetItem.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.url !== undefined) {
            obj.url = message.url;
        }
        if (message.linkUrl !== undefined) {
            obj.linkUrl = message.linkUrl;
        }
        if (message.height !== undefined) {
            obj.height = message.height;
        }
        if (message.width !== undefined) {
            obj.width = message.width;
        }
        if (message.iconUrl !== undefined) {
            obj.iconUrl = message.iconUrl;
        }
        if (message.name !== undefined) {
            obj.name = message.name;
        }
        if (message.prefixedName !== undefined) {
            obj.prefixedName = message.prefixedName;
        }
        if (message.isSubscribed !== undefined) {
            obj.isSubscribed = message.isSubscribed;
        }
        if (message.type !== undefined) {
            obj.type = message.type;
        }
        if (message.subscribers !== undefined) {
            obj.subscribers = message.subscribers;
        }
        if (message.communityIcon !== undefined) {
            obj.communityIcon = message.communityIcon;
        }
        if (message.isNsfw !== undefined) {
            obj.isNsfw = message.isNsfw;
        }
        if (message.text !== undefined) {
            obj.text = message.text;
        }
        if (message.children?.length) {
            obj.children = message.children.map((e) => MenuWidgetItem.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return GetWidgetsResponse_WidgetItem_Data.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetWidgetsResponse_WidgetItem_Data();
        message.url = object.url ?? undefined;
        message.linkUrl = object.linkUrl ?? undefined;
        message.height = object.height ?? undefined;
        message.width = object.width ?? undefined;
        message.iconUrl = object.iconUrl ?? undefined;
        message.name = object.name ?? undefined;
        message.prefixedName = object.prefixedName ?? undefined;
        message.isSubscribed = object.isSubscribed ?? undefined;
        message.type = object.type ?? undefined;
        message.subscribers = object.subscribers ?? undefined;
        message.communityIcon = object.communityIcon ?? undefined;
        message.isNsfw = object.isNsfw ?? undefined;
        message.text = object.text ?? undefined;
        message.children = object.children?.map((e) => MenuWidgetItem.fromPartial(e)) || [];
        return message;
    },
};
messageTypeRegistry.set(GetWidgetsResponse_WidgetItem_Data.$type, GetWidgetsResponse_WidgetItem_Data);
function createBaseGetWidgetsResponse_WidgetItem_Moderator() {
    return {
        name: "",
        authorFlairType: "",
        authorFlairTextColor: "",
        authorFlairBackgroundColor: "",
        authorFalirText: "",
        authorFlairRichtext: [],
    };
}
export const GetWidgetsResponse_WidgetItem_Moderator = {
    $type: "devvit.plugin.redditapi.widgets.GetWidgetsResponse.WidgetItem.Moderator",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.authorFlairType !== "") {
            writer.uint32(18).string(message.authorFlairType);
        }
        if (message.authorFlairTextColor !== "") {
            writer.uint32(26).string(message.authorFlairTextColor);
        }
        if (message.authorFlairBackgroundColor !== "") {
            writer.uint32(34).string(message.authorFlairBackgroundColor);
        }
        if (message.authorFalirText !== "") {
            writer.uint32(42).string(message.authorFalirText);
        }
        for (const v of message.authorFlairRichtext) {
            AuthorFlairRichText.encode(v, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetWidgetsResponse_WidgetItem_Moderator();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.authorFlairType = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.authorFlairTextColor = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.authorFlairBackgroundColor = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.authorFalirText = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.authorFlairRichtext.push(AuthorFlairRichText.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            authorFlairType: isSet(object.authorFlairType) ? globalThis.String(object.authorFlairType) : "",
            authorFlairTextColor: isSet(object.authorFlairTextColor) ? globalThis.String(object.authorFlairTextColor) : "",
            authorFlairBackgroundColor: isSet(object.authorFlairBackgroundColor)
                ? globalThis.String(object.authorFlairBackgroundColor)
                : "",
            authorFalirText: isSet(object.authorFalirText) ? globalThis.String(object.authorFalirText) : "",
            authorFlairRichtext: globalThis.Array.isArray(object?.authorFlairRichtext)
                ? object.authorFlairRichtext.map((e) => AuthorFlairRichText.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.authorFlairType !== "") {
            obj.authorFlairType = message.authorFlairType;
        }
        if (message.authorFlairTextColor !== "") {
            obj.authorFlairTextColor = message.authorFlairTextColor;
        }
        if (message.authorFlairBackgroundColor !== "") {
            obj.authorFlairBackgroundColor = message.authorFlairBackgroundColor;
        }
        if (message.authorFalirText !== "") {
            obj.authorFalirText = message.authorFalirText;
        }
        if (message.authorFlairRichtext?.length) {
            obj.authorFlairRichtext = message.authorFlairRichtext.map((e) => AuthorFlairRichText.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return GetWidgetsResponse_WidgetItem_Moderator.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetWidgetsResponse_WidgetItem_Moderator();
        message.name = object.name ?? "";
        message.authorFlairType = object.authorFlairType ?? "";
        message.authorFlairTextColor = object.authorFlairTextColor ?? "";
        message.authorFlairBackgroundColor = object.authorFlairBackgroundColor ?? "";
        message.authorFalirText = object.authorFalirText ?? "";
        message.authorFlairRichtext = object.authorFlairRichtext?.map((e) => AuthorFlairRichText.fromPartial(e)) || [];
        return message;
    },
};
messageTypeRegistry.set(GetWidgetsResponse_WidgetItem_Moderator.$type, GetWidgetsResponse_WidgetItem_Moderator);
function createBaseGetWidgetsResponse_WidgetItem_PostFlairTemplate() {
    return { text: "", richtext: [], backgroundColor: "", templateId: "", textColor: "", type: "" };
}
export const GetWidgetsResponse_WidgetItem_PostFlairTemplate = {
    $type: "devvit.plugin.redditapi.widgets.GetWidgetsResponse.WidgetItem.PostFlairTemplate",
    encode(message, writer = _m0.Writer.create()) {
        if (message.text !== "") {
            writer.uint32(10).string(message.text);
        }
        for (const v of message.richtext) {
            AuthorFlairRichText.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.backgroundColor !== "") {
            writer.uint32(26).string(message.backgroundColor);
        }
        if (message.templateId !== "") {
            writer.uint32(34).string(message.templateId);
        }
        if (message.textColor !== "") {
            writer.uint32(42).string(message.textColor);
        }
        if (message.type !== "") {
            writer.uint32(50).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetWidgetsResponse_WidgetItem_PostFlairTemplate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.richtext.push(AuthorFlairRichText.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.backgroundColor = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.templateId = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.textColor = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.type = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            richtext: globalThis.Array.isArray(object?.richtext)
                ? object.richtext.map((e) => AuthorFlairRichText.fromJSON(e))
                : [],
            backgroundColor: isSet(object.backgroundColor) ? globalThis.String(object.backgroundColor) : "",
            templateId: isSet(object.templateId) ? globalThis.String(object.templateId) : "",
            textColor: isSet(object.textColor) ? globalThis.String(object.textColor) : "",
            type: isSet(object.type) ? globalThis.String(object.type) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.richtext?.length) {
            obj.richtext = message.richtext.map((e) => AuthorFlairRichText.toJSON(e));
        }
        if (message.backgroundColor !== "") {
            obj.backgroundColor = message.backgroundColor;
        }
        if (message.templateId !== "") {
            obj.templateId = message.templateId;
        }
        if (message.textColor !== "") {
            obj.textColor = message.textColor;
        }
        if (message.type !== "") {
            obj.type = message.type;
        }
        return obj;
    },
    create(base) {
        return GetWidgetsResponse_WidgetItem_PostFlairTemplate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetWidgetsResponse_WidgetItem_PostFlairTemplate();
        message.text = object.text ?? "";
        message.richtext = object.richtext?.map((e) => AuthorFlairRichText.fromPartial(e)) || [];
        message.backgroundColor = object.backgroundColor ?? "";
        message.templateId = object.templateId ?? "";
        message.textColor = object.textColor ?? "";
        message.type = object.type ?? "";
        return message;
    },
};
messageTypeRegistry.set(GetWidgetsResponse_WidgetItem_PostFlairTemplate.$type, GetWidgetsResponse_WidgetItem_PostFlairTemplate);
function createBaseGetWidgetsResponse_WidgetItem_TemplatesEntry() {
    return { key: "", value: undefined };
}
export const GetWidgetsResponse_WidgetItem_TemplatesEntry = {
    $type: "devvit.plugin.redditapi.widgets.GetWidgetsResponse.WidgetItem.TemplatesEntry",
    encode(message, writer = _m0.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            GetWidgetsResponse_WidgetItem_PostFlairTemplate.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetWidgetsResponse_WidgetItem_TemplatesEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = GetWidgetsResponse_WidgetItem_PostFlairTemplate.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? GetWidgetsResponse_WidgetItem_PostFlairTemplate.fromJSON(object.value) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = GetWidgetsResponse_WidgetItem_PostFlairTemplate.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return GetWidgetsResponse_WidgetItem_TemplatesEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetWidgetsResponse_WidgetItem_TemplatesEntry();
        message.key = object.key ?? "";
        message.value = (object.value !== undefined && object.value !== null)
            ? GetWidgetsResponse_WidgetItem_PostFlairTemplate.fromPartial(object.value)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(GetWidgetsResponse_WidgetItem_TemplatesEntry.$type, GetWidgetsResponse_WidgetItem_TemplatesEntry);
function createBaseGetWidgetsResponse_ItemsEntry() {
    return { key: "", value: undefined };
}
export const GetWidgetsResponse_ItemsEntry = {
    $type: "devvit.plugin.redditapi.widgets.GetWidgetsResponse.ItemsEntry",
    encode(message, writer = _m0.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            GetWidgetsResponse_WidgetItem.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetWidgetsResponse_ItemsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = GetWidgetsResponse_WidgetItem.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? GetWidgetsResponse_WidgetItem.fromJSON(object.value) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = GetWidgetsResponse_WidgetItem.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return GetWidgetsResponse_ItemsEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetWidgetsResponse_ItemsEntry();
        message.key = object.key ?? "";
        message.value = (object.value !== undefined && object.value !== null)
            ? GetWidgetsResponse_WidgetItem.fromPartial(object.value)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(GetWidgetsResponse_ItemsEntry.$type, GetWidgetsResponse_ItemsEntry);
function createBaseMenuWidgetItem() {
    return { text: undefined, url: undefined, children: [] };
}
export const MenuWidgetItem = {
    $type: "devvit.plugin.redditapi.widgets.MenuWidgetItem",
    encode(message, writer = _m0.Writer.create()) {
        if (message.text !== undefined) {
            StringValue.encode({ value: message.text }, writer.uint32(10).fork()).ldelim();
        }
        if (message.url !== undefined) {
            StringValue.encode({ value: message.url }, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.children) {
            MenuWidgetItem.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMenuWidgetItem();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.text = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.url = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.children.push(MenuWidgetItem.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            text: isSet(object.text) ? String(object.text) : undefined,
            url: isSet(object.url) ? String(object.url) : undefined,
            children: globalThis.Array.isArray(object?.children)
                ? object.children.map((e) => MenuWidgetItem.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.text !== undefined) {
            obj.text = message.text;
        }
        if (message.url !== undefined) {
            obj.url = message.url;
        }
        if (message.children?.length) {
            obj.children = message.children.map((e) => MenuWidgetItem.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return MenuWidgetItem.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMenuWidgetItem();
        message.text = object.text ?? undefined;
        message.url = object.url ?? undefined;
        message.children = object.children?.map((e) => MenuWidgetItem.fromPartial(e)) || [];
        return message;
    },
};
messageTypeRegistry.set(MenuWidgetItem.$type, MenuWidgetItem);
function createBaseOrderWidgetsRequest() {
    return { subreddit: "", order: [] };
}
export const OrderWidgetsRequest = {
    $type: "devvit.plugin.redditapi.widgets.OrderWidgetsRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        for (const v of message.order) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOrderWidgetsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.order.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            order: globalThis.Array.isArray(object?.order) ? object.order.map((e) => globalThis.String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.order?.length) {
            obj.order = message.order;
        }
        return obj;
    },
    create(base) {
        return OrderWidgetsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOrderWidgetsRequest();
        message.subreddit = object.subreddit ?? "";
        message.order = object.order?.map((e) => e) || [];
        return message;
    },
};
messageTypeRegistry.set(OrderWidgetsRequest.$type, OrderWidgetsRequest);
function createBaseGetWidgetImageUploadLeaseRequest() {
    return { subreddit: "", filepath: "", mimetype: "" };
}
export const GetWidgetImageUploadLeaseRequest = {
    $type: "devvit.plugin.redditapi.widgets.GetWidgetImageUploadLeaseRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.filepath !== "") {
            writer.uint32(18).string(message.filepath);
        }
        if (message.mimetype !== "") {
            writer.uint32(26).string(message.mimetype);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetWidgetImageUploadLeaseRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.filepath = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.mimetype = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            filepath: isSet(object.filepath) ? globalThis.String(object.filepath) : "",
            mimetype: isSet(object.mimetype) ? globalThis.String(object.mimetype) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.filepath !== "") {
            obj.filepath = message.filepath;
        }
        if (message.mimetype !== "") {
            obj.mimetype = message.mimetype;
        }
        return obj;
    },
    create(base) {
        return GetWidgetImageUploadLeaseRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetWidgetImageUploadLeaseRequest();
        message.subreddit = object.subreddit ?? "";
        message.filepath = object.filepath ?? "";
        message.mimetype = object.mimetype ?? "";
        return message;
    },
};
messageTypeRegistry.set(GetWidgetImageUploadLeaseRequest.$type, GetWidgetImageUploadLeaseRequest);
function createBaseGetWidgetImageUploadLeaseResponse() {
    return { s3UploadLease: undefined, websocketUrl: "" };
}
export const GetWidgetImageUploadLeaseResponse = {
    $type: "devvit.plugin.redditapi.widgets.GetWidgetImageUploadLeaseResponse",
    encode(message, writer = _m0.Writer.create()) {
        if (message.s3UploadLease !== undefined) {
            GetWidgetImageUploadLeaseResponse_S3UploadLease.encode(message.s3UploadLease, writer.uint32(10).fork()).ldelim();
        }
        if (message.websocketUrl !== "") {
            writer.uint32(18).string(message.websocketUrl);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetWidgetImageUploadLeaseResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.s3UploadLease = GetWidgetImageUploadLeaseResponse_S3UploadLease.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.websocketUrl = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            s3UploadLease: isSet(object.s3UploadLease)
                ? GetWidgetImageUploadLeaseResponse_S3UploadLease.fromJSON(object.s3UploadLease)
                : undefined,
            websocketUrl: isSet(object.websocketUrl) ? globalThis.String(object.websocketUrl) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.s3UploadLease !== undefined) {
            obj.s3UploadLease = GetWidgetImageUploadLeaseResponse_S3UploadLease.toJSON(message.s3UploadLease);
        }
        if (message.websocketUrl !== "") {
            obj.websocketUrl = message.websocketUrl;
        }
        return obj;
    },
    create(base) {
        return GetWidgetImageUploadLeaseResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetWidgetImageUploadLeaseResponse();
        message.s3UploadLease = (object.s3UploadLease !== undefined && object.s3UploadLease !== null)
            ? GetWidgetImageUploadLeaseResponse_S3UploadLease.fromPartial(object.s3UploadLease)
            : undefined;
        message.websocketUrl = object.websocketUrl ?? "";
        return message;
    },
};
messageTypeRegistry.set(GetWidgetImageUploadLeaseResponse.$type, GetWidgetImageUploadLeaseResponse);
function createBaseGetWidgetImageUploadLeaseResponse_S3UploadLease() {
    return { action: "", fields: [] };
}
export const GetWidgetImageUploadLeaseResponse_S3UploadLease = {
    $type: "devvit.plugin.redditapi.widgets.GetWidgetImageUploadLeaseResponse.S3UploadLease",
    encode(message, writer = _m0.Writer.create()) {
        if (message.action !== "") {
            writer.uint32(10).string(message.action);
        }
        for (const v of message.fields) {
            GetWidgetImageUploadLeaseResponse_S3UploadLease_NameValuePair.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetWidgetImageUploadLeaseResponse_S3UploadLease();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.action = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.fields.push(GetWidgetImageUploadLeaseResponse_S3UploadLease_NameValuePair.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            action: isSet(object.action) ? globalThis.String(object.action) : "",
            fields: globalThis.Array.isArray(object?.fields)
                ? object.fields.map((e) => GetWidgetImageUploadLeaseResponse_S3UploadLease_NameValuePair.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.action !== "") {
            obj.action = message.action;
        }
        if (message.fields?.length) {
            obj.fields = message.fields.map((e) => GetWidgetImageUploadLeaseResponse_S3UploadLease_NameValuePair.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return GetWidgetImageUploadLeaseResponse_S3UploadLease.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetWidgetImageUploadLeaseResponse_S3UploadLease();
        message.action = object.action ?? "";
        message.fields =
            object.fields?.map((e) => GetWidgetImageUploadLeaseResponse_S3UploadLease_NameValuePair.fromPartial(e)) || [];
        return message;
    },
};
messageTypeRegistry.set(GetWidgetImageUploadLeaseResponse_S3UploadLease.$type, GetWidgetImageUploadLeaseResponse_S3UploadLease);
function createBaseGetWidgetImageUploadLeaseResponse_S3UploadLease_NameValuePair() {
    return { name: "", value: "" };
}
export const GetWidgetImageUploadLeaseResponse_S3UploadLease_NameValuePair = {
    $type: "devvit.plugin.redditapi.widgets.GetWidgetImageUploadLeaseResponse.S3UploadLease.NameValuePair",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetWidgetImageUploadLeaseResponse_S3UploadLease_NameValuePair();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            value: isSet(object.value) ? globalThis.String(object.value) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.value !== "") {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return GetWidgetImageUploadLeaseResponse_S3UploadLease_NameValuePair.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetWidgetImageUploadLeaseResponse_S3UploadLease_NameValuePair();
        message.name = object.name ?? "";
        message.value = object.value ?? "";
        return message;
    },
};
messageTypeRegistry.set(GetWidgetImageUploadLeaseResponse_S3UploadLease_NameValuePair.$type, GetWidgetImageUploadLeaseResponse_S3UploadLease_NameValuePair);
function createBaseCustomWidget() {
    return { id: "", kind: "", shortName: "", text: "", height: 0, css: "", imageData: [], styles: undefined };
}
export const CustomWidget = {
    $type: "devvit.plugin.redditapi.widgets.CustomWidget",
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.kind !== "") {
            writer.uint32(18).string(message.kind);
        }
        if (message.shortName !== "") {
            writer.uint32(26).string(message.shortName);
        }
        if (message.text !== "") {
            writer.uint32(34).string(message.text);
        }
        if (message.height !== 0) {
            writer.uint32(48).int32(message.height);
        }
        if (message.css !== "") {
            writer.uint32(58).string(message.css);
        }
        for (const v of message.imageData) {
            WidgetImage.encode(v, writer.uint32(66).fork()).ldelim();
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(74).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCustomWidget();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.height = reader.int32();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.css = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.imageData.push(WidgetImage.decode(reader, reader.uint32()));
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            height: isSet(object.height) ? globalThis.Number(object.height) : 0,
            css: isSet(object.css) ? globalThis.String(object.css) : "",
            imageData: globalThis.Array.isArray(object?.imageData)
                ? object.imageData.map((e) => WidgetImage.fromJSON(e))
                : [],
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.height !== 0) {
            obj.height = Math.round(message.height);
        }
        if (message.css !== "") {
            obj.css = message.css;
        }
        if (message.imageData?.length) {
            obj.imageData = message.imageData.map((e) => WidgetImage.toJSON(e));
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        return obj;
    },
    create(base) {
        return CustomWidget.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCustomWidget();
        message.id = object.id ?? "";
        message.kind = object.kind ?? "";
        message.shortName = object.shortName ?? "";
        message.text = object.text ?? "";
        message.height = object.height ?? 0;
        message.css = object.css ?? "";
        message.imageData = object.imageData?.map((e) => WidgetImage.fromPartial(e)) || [];
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(CustomWidget.$type, CustomWidget);
function createBaseAddCustomWidgetRequest() {
    return { subreddit: "", shortName: "", text: "", height: 0, css: "", imageData: [], styles: undefined };
}
export const AddCustomWidgetRequest = {
    $type: "devvit.plugin.redditapi.widgets.AddCustomWidgetRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.shortName !== "") {
            writer.uint32(18).string(message.shortName);
        }
        if (message.text !== "") {
            writer.uint32(26).string(message.text);
        }
        if (message.height !== 0) {
            writer.uint32(32).int32(message.height);
        }
        if (message.css !== "") {
            writer.uint32(42).string(message.css);
        }
        for (const v of message.imageData) {
            WidgetImage.encode(v, writer.uint32(50).fork()).ldelim();
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAddCustomWidgetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.height = reader.int32();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.css = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.imageData.push(WidgetImage.decode(reader, reader.uint32()));
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            height: isSet(object.height) ? globalThis.Number(object.height) : 0,
            css: isSet(object.css) ? globalThis.String(object.css) : "",
            imageData: globalThis.Array.isArray(object?.imageData)
                ? object.imageData.map((e) => WidgetImage.fromJSON(e))
                : [],
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.height !== 0) {
            obj.height = Math.round(message.height);
        }
        if (message.css !== "") {
            obj.css = message.css;
        }
        if (message.imageData?.length) {
            obj.imageData = message.imageData.map((e) => WidgetImage.toJSON(e));
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        return obj;
    },
    create(base) {
        return AddCustomWidgetRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddCustomWidgetRequest();
        message.subreddit = object.subreddit ?? "";
        message.shortName = object.shortName ?? "";
        message.text = object.text ?? "";
        message.height = object.height ?? 0;
        message.css = object.css ?? "";
        message.imageData = object.imageData?.map((e) => WidgetImage.fromPartial(e)) || [];
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(AddCustomWidgetRequest.$type, AddCustomWidgetRequest);
function createBaseUpdateCustomWidgetRequest() {
    return { subreddit: "", id: "", shortName: "", text: "", height: 0, css: "", imageData: [], styles: undefined };
}
export const UpdateCustomWidgetRequest = {
    $type: "devvit.plugin.redditapi.widgets.UpdateCustomWidgetRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.id !== "") {
            writer.uint32(18).string(message.id);
        }
        if (message.shortName !== "") {
            writer.uint32(26).string(message.shortName);
        }
        if (message.text !== "") {
            writer.uint32(34).string(message.text);
        }
        if (message.height !== 0) {
            writer.uint32(40).int32(message.height);
        }
        if (message.css !== "") {
            writer.uint32(50).string(message.css);
        }
        for (const v of message.imageData) {
            WidgetImage.encode(v, writer.uint32(58).fork()).ldelim();
        }
        if (message.styles !== undefined) {
            WidgetStyles.encode(message.styles, writer.uint32(66).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateCustomWidgetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.height = reader.int32();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.css = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.imageData.push(WidgetImage.decode(reader, reader.uint32()));
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.styles = WidgetStyles.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            height: isSet(object.height) ? globalThis.Number(object.height) : 0,
            css: isSet(object.css) ? globalThis.String(object.css) : "",
            imageData: globalThis.Array.isArray(object?.imageData)
                ? object.imageData.map((e) => WidgetImage.fromJSON(e))
                : [],
            styles: isSet(object.styles) ? WidgetStyles.fromJSON(object.styles) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.height !== 0) {
            obj.height = Math.round(message.height);
        }
        if (message.css !== "") {
            obj.css = message.css;
        }
        if (message.imageData?.length) {
            obj.imageData = message.imageData.map((e) => WidgetImage.toJSON(e));
        }
        if (message.styles !== undefined) {
            obj.styles = WidgetStyles.toJSON(message.styles);
        }
        return obj;
    },
    create(base) {
        return UpdateCustomWidgetRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateCustomWidgetRequest();
        message.subreddit = object.subreddit ?? "";
        message.id = object.id ?? "";
        message.shortName = object.shortName ?? "";
        message.text = object.text ?? "";
        message.height = object.height ?? 0;
        message.css = object.css ?? "";
        message.imageData = object.imageData?.map((e) => WidgetImage.fromPartial(e)) || [];
        message.styles = (object.styles !== undefined && object.styles !== null)
            ? WidgetStyles.fromPartial(object.styles)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(UpdateCustomWidgetRequest.$type, UpdateCustomWidgetRequest);
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
